
import { CommonModule } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import {
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';
import { AlertService } from '../../../core/services/alert/alert.service';
import { updatePipe, updatePipe2, updatePipe3, updatePipe4,updatePipe4Private,updatePipe5, vinEventPipe } from '../../../core/pipe/custom-pipes';
import { StocksService } from '../../../core/services/stocks/stocks.service';


interface Event {
  created_by: string;
  message: string;
  time: string;
  values: string[];
}

interface Item {
  date: string;
  events: Event[];
}
@Component({
  selector: 'app-timeline',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    updatePipe,
    updatePipe2,
    updatePipe3,
    updatePipe4,
    updatePipe5,
    updatePipe4Private,
    vinEventPipe,
    ReactiveFormsModule,
  ],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.css',
})
export class TimelineComponent {
  @Input() campaign_reference?: any;
  @Input() stock_reference?: any;
  timelineItems: any[] = [];
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private campaignsService: CampaignsService,
    private stockService: StocksService,
    private alertService: AlertService
  ) {
    this.form = this.fb.group({
      campaign_id: [''],
      public: [true],
      content: [''],
    });
  }

  ngOnInit(  ): void {console.log();
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['campaign_reference']) {
      this.form.patchValue({
        campaign_id: this.campaign_reference,
      });
      this.getTimeline(this.campaign_reference);
    } else {
    }
    if (changes['stock_reference']) {
      
      this.getTimelineStock(this.stock_reference);
    } else {
    }
  }

  formatDate(fecha: string): string {
    const date = new Date(fecha);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  getTimeline(campaign_reference: string = this.campaign_reference) {
    if (campaign_reference) {
      this.campaign_reference = campaign_reference;
    }
    this.alertService.loading('swal_messages.please_wait');
    this.campaignsService.getTimeline(this.campaign_reference).subscribe({
      next: (data) => {
        this.timelineItems = data.data;
        this.timelineItems.sort((a, b) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        this.timelineItems = this.combineEventsByDate(this.timelineItems);
        this.timelineItems = this.sortItemsByDateDesc(this.timelineItems);
        this.timelineItems.forEach((day :Item) => {
          day.events.sort((a, b) => {
              return   this.timeToNumber(b.time) - this.timeToNumber(a.time)
          });
      });
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.close();
      },
    });
  }
  
  getTimelineStock(stock_reference: string = this.stock_reference) {
    if (stock_reference) {
      this.stock_reference = stock_reference;
    }
    this.alertService.loading('swal_messages.please_wait');
    this.stockService.getTimeline(this.stock_reference).subscribe({
      next: (data) => {
        this.timelineItems = data.data;
        this.timelineItems.sort((a, b) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        this.timelineItems = this.combineEventsByDate(this.timelineItems);
        this.timelineItems = this.sortItemsByDateDesc(this.timelineItems);
        this.timelineItems.forEach((day :Item) => {
          day.events.sort((a, b) => {
              return   this.timeToNumber(b.time) - this.timeToNumber(a.time)
          });
      });
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.close();
      },
    });
  }

   timeToNumber(time:any) {
    return parseInt(time.replace(/:/g, ''));
}
  combineEventsByDate(items: Item[]): Item[] {
    const combined: Item[] = items.reduce((acc: Item[], item: Item) => {
      const existingItem = acc.find(i => i.date === item.date);
      if (existingItem) {
        existingItem.events = [...existingItem.events, ...item.events];
      } else {
        acc.push({ ...item });
      }
      return acc;
    }, []);

    return combined;
  }

  sortItemsByDateDesc(items: Item[]): Item[] {
    return items.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
  }

  getDivClass(origin: string) {
    switch (origin) {
      case 'team':
        return 'div-icon-team';
      case 'external':
        return 'div-icon-other';
      case 'automation':
        return 'div-icon-automation';
      default:
        return 'div-icon-team';
    }
  }

  getIcon(icon: string) {
    switch (icon) {
      case 'notes_risk':
        return 'icon-clipboard-alert';
      case 'notes':
        return 'icon-clipboard-pencil';
      case 'updates':
        return 'icon-pencil';
      case 'status':
        return 'icon-sync';
      case 'stages':
        return 'icon-sync';
      case 'creation':
      case 'creation_campaign_stock':
        return 'icon-plus-circle';
      case 'documents':
        return 'icon-upload';
      case 'vin_added':
        return 'icon-plus-circle';
      case 'vin_updated':
        return 'icon-pencil';
      case 'vin_removed':
        return 'icon-trash';
      case 'vins_imported':
        return 'icon-upload';
      case 'broker_excluded':
        return 'icon-user-minus';
      case 'broker_included':
        return 'icon-user-plus';
      default:
        return 'icon-pencil';
    }
  }
}
